import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Page from 'components/widgets/Route';
import * as actions from './actions';
import ComponentsList from './container/ComponentsList';

class ComponentsRoute extends React.Component {
	constructor(props) {
		super(props);
		this.fetchComponents = this.fetchComponents.bind(this);
	}

	fetchComponents() {
		this.props.actions.fetchComponents();
	}

	render() {
		const { match: { path } } = this.props;
		return (
			<Page>
				<Page.Route
					exact
					path={path}
					onEnter={this.fetchComponents}
					component={ComponentsList}
				/>
			</Page>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

ComponentsRoute.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired
};

export default connect(
	null,
	mapDispatchToProps
)(ComponentsRoute);
